import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

const Learning = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const [learning, setLearning] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('asc');
    const [deletePending, setDeletePending] = useState(false)
    const [addPending, setAddPending] = useState(false)
    const [learningPending, setLearningPending] = useState(false)

    //INTERCEPTOR
        // Create an instance of Axios
        const api = axios.create({
            baseURL: `${base_url}`
        });
    
        // Set the authorization token for all requests
        api.interceptors.request.use((config) => {
            // Add your authorization token logic here
            const token = sessionStorage.getItem('token');
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        });
    const deleteLearningSuccess = (msg) =>
        toast.success(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
    const deleteLearningError = (msg) =>
        toast.error(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLearningPending(true)
        try {
            const response = await api.get(`${base_url}/learning/get-all-learning/`);
            setLearning(response.data.result);
            setLearningPending(false)
        } catch (error) {
            console.log(error);
        }
    };

    const handleDelete = (id) => {
        setDeletePending(true)
        api
            .post(`${base_url}/learning/${id}`)
            .then(function (response) {
                console.log(response.data);
                fetchData();
                setDeletePending(false)
                deleteLearningSuccess("Learning record was successfully deleted");
            })
            .catch(function (error) {
                console.log(error.response.data.message);
                deleteLearningError("An error occured while trying to fetch Learning data")             
            });
    };  

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    // Sort learning array based on sortOrder
    const sortedLearning = sortOrder === 'asc' ? [...learning] : [...learning].reverse();

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedLearning.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // modal content ==================================================================================================

    // const base_url = process.env.REACT_APP_BASE_URL;

    const [newlearning, setNewLearning] = useState("");
    const [link, setLink] = useState("");

    const addLearningSuccess = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        setAddPending(true)
        //check phone verification status
        api.post(`${base_url}/learning/add-learning/`, {
            "learning": newlearning,
            "link": link
        })
            .then(function (response) {
                console.log(response.data)
                setNewLearning("")
                setLink("")
                addLearningSuccess("Learning Entry was successfully added")
                fetchData()
                setAddPending(false)
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    // =================================================================================================================

    // Added by VM

    // navigation options
    const nextPage = () => {
        if (currentPage < Math.ceil(sortedLearning.length / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstPage = () => {
        setCurrentPage(1);
    };

    const lastPage = () => {
        setCurrentPage(Math.ceil(sortedLearning.length / itemsPerPage));
    };

    const pageButtons = () => {
        const totalPages = Math.ceil(sortedLearning.length / itemsPerPage);
        const buttons = [];

        // Display up to 3 page numbers ahead of the current page
        for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };
    // end navigation options

    return (
        <>
            <div>
                {/* <ToastContainer /> */}
                <div className="d-flex my-1">
                    <div className="pt-3">
                        <h6 className="section-title">
                            <i className="bi-book"></i> LEARNING
                            <small className="text-secondary" style={{fontWeight:"400",fontSize:"smaller"}}> ({learning.length})</small>
                        </h6>
                    </div>
                    <div className="flex-fill text-end">
                        <button
                            className="btn-custom"
                            data-bs-toggle="modal"
                            data-bs-target="#add-learning"
                        >
                            <i className="bi bi-plus-circle"></i> Add
                        </button>
                        <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                            {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                        </button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead className="table-dark">
                            <tr>
                                <th>ID</th>
                                <th>Learning</th>
                                <th>Link</th>
                                <th>Created on</th>
                                <th>Action</th>
                            </tr>

                        </thead>
                        <tbody>
                            {
                                learningPending ? (
                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                                        </td>
                                    </tr>
                                ) : (
                                    currentItems.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.learning}</td>
                                            <td>{item.link}</td>
                                            <td>{moment(item.createdAt).format('DD MMM YYYY h:mm:ss a')}</td>
                                            <td>
                                                {/* {
                                                deletePending ? (
                                                    <button className="btn-custom-sm disabled-btn" disabled>
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                ) : (
                                                    <button className="btn-custom-sm" onClick={() => handleDelete(item.id)}>
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                )
                                            } */}
                                                <button className="btn-custom-sm" onClick={() => handleDelete(item.id)}>
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </td>

                                        </tr>
                                    ))
                                )
                            }
                        </tbody>
                    </table>

                    <div className="pagination btn-group">
                        <button
                            className="btn-pagination"
                            onClick={firstPage}
                            disabled={currentPage === 1}
                        >
                            First
                        </button>

                        <button
                            className="btn-pagination"
                            onClick={prevPage}
                            disabled={currentPage === 1}
                        >
                            <i className="bi-chevron-left"></i>
                        </button>

                        {/* page numbered buttons */}
                        {pageButtons()}

                        <button
                            className="btn-pagination"
                            onClick={nextPage}
                            disabled={currentPage === Math.ceil(sortedLearning.length / itemsPerPage)}
                        >
                            <i className="bi-chevron-right"></i>
                        </button>

                        <button
                            className="btn-pagination"
                            onClick={lastPage}
                            disabled={currentPage === Math.ceil(sortedLearning.length / itemsPerPage)}
                        >
                            Last
                        </button>
                    </div>
                </div>

                {/* Commented out by Victoria Matthews */}
                {/* Pagination */}
                {/* <div className="pagination">
                    {Array.from({ length: Math.ceil(sortedLearning.length / itemsPerPage) }, (_, index) => (
                        <button
                            key={index}
                            className={`${currentPage === index + 1 ? 'active-pagination-btn' : 'pagination-btn'}`}
                            onClick={() => paginate(index + 1)}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div> */}
            </div >
            {/* Modal data content */}
            < div className="modal fade" id="add-learning" >
                <div className="modal-dialog modal-md">
                    <div className="modal-content">

                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <h5 className="modal-title bold"><i className="bi bi-plus-circle"></i> Add Learning</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        {/* <!-- Modal body --> */}
                        <div className="modal-body">
                            <div className="container-fluid">

                                <form onSubmit={handleSubmit}>
                                    <div className="input-group my-3">
                                        <span class="input-group-text input-group-text-custom"><i class="bi bi-pencil"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={newlearning} onChange={(e) => setNewLearning(e.target.value)} placeholder="Learning" required />
                                    </div>
                                    <div className="input-group my-3">
                                        <span class="input-group-text input-group-text-custom"><i class="bi bi-link"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={link} onChange={(e) => setLink(e.target.value)} placeholder="Link" required />
                                    </div>
                                    {
                                        addPending ? (
                                            <button type="submit" className="btn-custom w-100 disabled" disabled>
                                                <span class="spinner-border spinner-border-sm"></span>
                                            </button>
                                        ) : (
                                            <button type="submit" className="btn-custom w-100">Submit</button>
                                        )
                                    }
                                </form>
                            </div>
                        </div>

                        {/* <!-- Modal footer --> */}
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div >
            {/* End modal data content */}
        </>
    );
};

export default Learning;

